import React, { useEffect, useState, useContext } from "react";
import Calendar from "react-calendar";

import { Typography } from "@material-ui/core";
import moment from "moment";
import "moment-timezone";
import "react-calendar/dist/Calendar.css";

import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import appointmentFormStyle from "../styles";
import { useFormikContext } from "formik";

import { SchedulerContext } from "../../../context/schedulerContext";

function Appointment(props) {
  const {
    setIsNextdisabled,
    availableSlots,
    availableDates,
    appointmentObj,
    setIsLoading,
    IsAvialableSlotsCompleted,
  } = props;
  const classes = appointmentFormStyle();
  const { setFieldValue, values } = useFormikContext();
  const { schedulerData } = useContext(SchedulerContext);
  const shortTimeZone = moment.tz(schedulerData?.Timezone).zoneAbbr();
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [selectedTime, setSelectedTime] = useState([]);
  const [selectedTimeValue, setSelectedTimeValue] = useState("");
  const [availableSpace, setAvailableSpace] = useState(0);
  const [cardSlotSize, setCardSlotSize] = useState(0);
  const [cardSlots, setCardSlots] = useState([]);

  const isMobile = window.innerWidth <= 480;
  const isSmallDevice = window.innerWidth <= 380;

  useEffect(() => {
    setIsNextdisabled(true);
    // Function to calculate the available space between two divs
    function calculateAvailableSpace() {
      const div1 = document.getElementById("id-calendar-div");
      const div2 = document.getElementById("id-footer-div");

      if (div1 && div2) {
        const rect1 = div1.getBoundingClientRect();
        const rect2 = div2.getBoundingClientRect();

        // Calculate the available vertical space between the two divs
        const space = rect2.top - (rect1.top + rect1.height) - 44; // -44 px where we used to display text and  padding stuff
        const timeSlotCardSpaceAvailable = isSmallDevice
          ? space - 16
          : space - 32; // space available after minus 16px bottom top padding of card
        const count = Math.floor(timeSlotCardSpaceAvailable / 48); // pixels per slot including gap

        setCardSlotSize(count);
        setAvailableSpace(space.toFixed(2));
      }
    }

    calculateAvailableSpace();
    window.addEventListener("resize", calculateAvailableSpace);

    // Clean up the event listener when the component unmounts
    return () => {
      window.removeEventListener("resize", calculateAvailableSpace);
    };
  }, []);

  useEffect(() => {
    if (availableDates !== undefined && availableDates?.length > 0) {
      const todayDate = moment().format("YYYY-MM-DD");
      setSelectedTime(availableSlots[todayDate]);
      setFieldValue("appointmentDate", todayDate);
      setFieldValue("appointmentTime", availableSlots[todayDate]);
    } else {
      setSelectedTime([]);
      setFieldValue("appointmentDate", "");
      setFieldValue("appointmentTime", []);
      setIsNextdisabled(true);
    }

    if (
      appointmentObj?.customerId !== "" &&
      appointmentObj?.customerId !== undefined
    ) {
      setFieldValue("appointmentObj", appointmentObj);
    }
  }, [availableSlots, availableDates, appointmentObj]);

  useEffect(() => {
    if (cardSlotSize > 0) {
      const cardSlotsArray = divideArrayIntoSlots(selectedTime, cardSlotSize);
      setCardSlots(cardSlotsArray);
    }
  }, [cardSlotSize, selectedTime]);

  const divideArrayIntoSlots = (arr, slotSize) => {
    if (slotSize <= 0) {
      console.log("Slot size must be greater than 0");
    }

    const dividedArray = [];
    for (let i = 0; i < arr?.length; i += slotSize) {
      const slot = arr.slice(i, i + slotSize);
      dividedArray.push(slot);
    }

    return dividedArray;
  };

  const _handleTimeChange = (event, time) => {
    setSelectedTimeValue(event.target.value);
    setFieldValue("appointmentTime", time);
    setIsNextdisabled(false);
  };

  const _handleDateChange = (date) => {
    const dateStr = moment(date).format("YYYY-MM-DD");

    setSelectedDate(dateStr);
    setSelectedTime(availableSlots[dateStr]);
    setFieldValue("appointmentDate", dateStr);
    setFieldValue("appointmentTime", "");
    setSelectedTimeValue("");
    setIsNextdisabled(true);
  };

  return (
    <div className={classes.calenderWrap}>
      <div id="id-calendar-div">
        <Calendar
          selectRange={false}
          onChange={_handleDateChange}
          // defaultActiveStartDate={new Date(centralTime)}
          //value={new Date(selectedDate)}
          minDate={new Date()} // Set minDate to current date
          calendarType="US"
          formatMonthYear={(locale, date) =>
            date.toLocaleString(locale, { month: "short", year: "numeric" })
          }
          className={classes.calenderField}
        />
      </div>

      {IsAvialableSlotsCompleted && (
        <>
          {isMobile ? (
            <>
              {selectedTime?.length > 0 ? (
                <div
                  style={{
                    background: "#F2F0FA",
                    paddingTop: "1rem",
                    paddingBottom: "0rem",
                    height: "100%",
                  }}
                >
                  <span
                    style={{
                      paddingLeft: "1.5rem",
                      paddingRight: "1.5rem",
                    }}
                    className={classes.selectTimeSlotText}
                  >
                    Please select one of the available time slots{" "}
                  </span>
                  <RadioGroup
                    id="autoAdjustDiv"
                    style={{
                      justifyContent: "space-between",
                    }}
                    aria-labelledby="demo-controlled-radio-buttons-group"
                    name="appointmentTime"
                    value={selectedTimeValue}
                  >
                    <div
                      className={classes.scrollCardDiv}
                      style={{
                        height: `calc(${availableSpace}px )`,
                        maxHeight: `calc(${availableSpace}px)`,
                      }}
                    >
                      {cardSlots?.map((cardSlot, index) => {
                        return (
                          <div
                            key={`card-parent-${index}`}
                            style={{
                              padding: "8px 8px 8px 16px",
                              gap: "10px",
                              borderRadius: "16px",
                              border: "1px #D3D7E1",
                              background: "#FFFFFF",
                              height: "fit-content",
                              margin: "1rem",
                              maxHeight: isSmallDevice
                                ? `calc(${availableSpace}px)`
                                : `calc(${availableSpace}px - 32px)`,
                              marginTop: isSmallDevice ? "0rem" : "1rem",
                              marginBottom: isSmallDevice ? "0rem" : "1rem",
                              display: "grid",

                              width: "268px",
                            }}
                          >
                            {cardSlot?.map((time, index) => {
                              const startTime = moment(
                                time?.start,
                                "HH:mm"
                              ).format("hh:mm A");
                              const endTime = moment(time?.end, "HH:mm").format(
                                "hh:mm A"
                              );
                              return (
                                <>
                                  <FormControlLabel
                                    key={`card-${index}`}
                                    id={`timeId-${index}`}
                                    value={`${time?.start}-${time?.end}`}
                                    onChange={(event) =>
                                      _handleTimeChange(event, time)
                                    }
                                    control={<Radio />}
                                    label={`${startTime} - ${endTime}`}
                                  />
                                </>
                              );
                            })}
                          </div>
                        );
                      })}
                    </div>
                  </RadioGroup>
                </div>
              ) : (
                <div className={classes.timeSlotdiv}>
                  <Typography
                    variant="p"
                    style={{
                      color: "#8B0000",
                      paddingTop: "1rem",
                      display: "block",
                      fontSize: ".938rem",
                      lineHeight: "1.5rem",
                      fontStyle: "italic",
                    }}
                  >
                    There are no openings remaining for this date. Please select
                    a different date, or call us if this is an emergency.
                  </Typography>
                </div>
              )}
            </>
          ) : (
            <div className={classes.timeSlotdiv}>
              {selectedTime?.length > 0 ? (
                <>
                  <span className={classes.selectTimeSlotText}>
                    Please select one of the available time slots{" "}
                  </span>
                  <RadioGroup
                    id="autoAdjustDiv"
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-between",
                      maxHeight: `${availableSpace}px`,
                      overflowY: "scroll",
                      overflowX: "hidden",
                    }}
                    aria-labelledby="demo-controlled-radio-buttons-group"
                    name="appointmentTime"
                    value={selectedTimeValue}
                  >
                    {selectedTime?.length > 0 &&
                      selectedTime?.map((time, index) => {
                        const startTime = moment(time?.start, "HH:mm").format(
                          "hh:mm A"
                        );
                        const endTime = moment(time?.end, "HH:mm").format(
                          "hh:mm A"
                        );
                        return (
                          <>
                            <FormControlLabel
                              key={index}
                              id={`timeId-${index}`}
                              value={`${time?.start}-${time?.end}`}
                              onChange={(event) =>
                                _handleTimeChange(event, time)
                              }
                              control={<Radio />}
                              label={`${startTime} - ${endTime}`}
                            />
                          </>
                        );
                      })}
                  </RadioGroup>
                </>
              ) : (
                <Typography
                  variant="p"
                  style={{
                    color: "#8B0000",
                    paddingTop: "1rem",
                    display: "block",
                    fontSize: ".938rem",
                    lineHeight: "1.5rem",
                    fontStyle: "italic",
                  }}
                >
                  There are no openings remaining for this date. Please select a
                  different date, or call us if this is an emergency.
                </Typography>
              )}
            </div>
          )}
        </>
      )}
    </div>
  );
}
export default Appointment;
